module.exports = __webpack_public_path__ + "static/img/digg-comment-check.abae4fc7.png";